<template>
  <footer class="main-footer">
    <section class="logo container">
      <div class="logo__container">
        <img src="../assets/logo.png" alt="Sequire Logo">
      </div>
      <div class="contact__container">
        <h3>Contact Us</h3>
        <a href="tel:+18053176908"><p>+1 805 317 6908</p></a>
      </div>
    </section>
  </footer>
</template>

<style lang="scss" scoped>
  @import '@/styles/components/footer.scss';
</style>

<script>
export default {
  name: 'Footer',
};
</script>